import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { Link } from 'react-router-dom';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `The Lie of the Truth by René Daumal | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `In this brief, dense essay, Daumal bids us to resist the very notion of the truth, and to recognize it as an artistic and metaphysical dead - end.`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-One/ReneDaumal_Mockup1.webp', '../../Series-One/ReneDaumal_Mockup2.webp', '../../Series-One/ReneDaumal_Mockup3.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>The Lie of the Truth</h1>
            <div className='productAuthor'>René Daumal</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798989378050'} />
            <div className='productPrice'>$12.99 USD</div>
          </div>

          <div className='productDescription'><em>The Lie of the Truth</em>, René Daumal's brief, dense essay, bids us to resist the very notion of the truth, and to recognize it as an artistic and metaphysical dead-end.
          </div>
          <div className='productDescription'>
            <p><strong>René Daumal</strong> (1908-1944) was a French poet and writer often associated with surrealism (though he fought against the label), spiritualism, and ‘pataphysics.’ He is perhaps best remembered for the posthumously published novel, <em>Mount Analogue</em> (1952).</p>
          </div>
          <div className='productMetadata'>
            <div>Series I</div>
            <div>Autumn 2023</div>
            <div>ISBN 9798989378050</div>
            <div>4.125 x 2.75 x 0.54 inches</div>
            <div>60 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}